import MoreVert from '@material-ui/icons/MoreVert';
import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import React from 'react';
import { Menu } from './Menu';
import { MenuColor } from './styled';

function translateMenuColorToButtonColor(
  color: MenuColor,
): React.ComponentProps<typeof IconButton>['color'] {
  switch (color) {
    case 'primary':
      return 'primary';
    case 'danger':
      return 'secondary';
    case 'secondary':
    default:
      return 'default';
  }
}

type ActionMenuProps = {
  options: React.ComponentProps<typeof Menu>['options'];
  altText?: string;
  color?: MenuColor;
  isDisabled?: boolean;
};

export function ActionMenu({
  options,
  altText = 'Action menu',
  color = 'primary',
  isDisabled = false,
}: ActionMenuProps) {
  return (
    <Menu
      color={color}
      options={options}
      buttonElement={
        <IconButton
          color={translateMenuColorToButtonColor(color)}
          disabled={isDisabled}
        >
          <MoreVert />
          <VisuallyHidden>{altText}</VisuallyHidden>
        </IconButton>
      }
    />
  );
}
